<template>
  <div id="acceptance">
    <el-row>
      <el-col :span="12">
        <h3>Select a tournament</h3>
        <el-select
            placeholder="Select"
            value
            @change="selectTournament"
            v-model="tournamentIdentifier"
        >
          <el-option
              v-for="item in tournaments"
              :key="item.tournamentId"
              :label="item.name"
              :value="item.tournamentId"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
                moment(item.startDate).format("MMM DD")
              }}</span>
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <div
        v-if="!entries || !entries.edition"
        class="result-area"
        :key="componentKey"
    >
      <p>
        No data to display currently. Either you have not selected a tournament
        or the tournament you have selected has no acceptance list entries yet.
      </p>
    </div>

    <div v-if="entries && entries.edition" :key="componentKey">
      <table style="width: 100%" class="result-area">
        <tr>
          <td>Tournament Name: {{ entries.edition.name }}</td>
          <td>
            Tournament Level: {{ tourLevelFormatter(entries.edition.level) }}
          </td>
        </tr>
        <tr>
          <td>Surface: {{ entries.edition.surface }}</td>
          <td>Prize Money: {{ entries.edition.prizeMoney | toCurrency }}</td>
        </tr>
        <tr>
          <td>
            Week of Year: {{ moment(entries.edition.startDate).week() }}, Start:
            {{ moment(entries.edition.startDate).format("DD MMM YYYY") }}
          </td>
          <td>Draw Size: {{ entries.edition.double.main.size }}</td>
        </tr>
        <tr>
          <td>Direct In: {{ entries.edition.double.main.numberOfDirects }}</td>
        </tr>
      </table>

      <h3 style="padding-top: 20px">
        Acceptance List for {{ entries.edition.name }}
      </h3>
      <div class="result-area">
        This is the final Acceptance List for this tournament.
      </div>
      <h2>Doubles Draw</h2>
      <el-table :border="false" :data="entries.draw" class="result-table">
        <el-table-column label="Pos" type="index" width="60"></el-table-column>
        <el-table-column label="Combined Rank" width="120">
          <template slot-scope="scope">{{ scope.row.rank }}</template>
        </el-table-column>
        <el-table-column label="Player" width="200">
          <template slot-scope="scope"
          >{{ scope.row.player.lastName }}, {{ scope.row.player.firstName }}
            {{
              suppressBlrRusNationality(scope.row.player.nationality)
            }}
          </template
          >
        </el-table-column>
        <el-table-column label="Player Rank" width="135">
          <template slot-scope="scope"
          >{{ scope.row.effectivePlayerRank }}
            {{ scope.row.playerUsesSpecialRank ? "SR" : "" }}
          </template
          >
        </el-table-column>
        <el-table-column label="Partner" width="200">
          <template slot-scope="scope"
          >{{ scope.row.partner.lastName }},
            {{ scope.row.partner.firstName }}
            {{
              suppressBlrRusNationality(scope.row.partner.nationality)
            }}
          </template
          >
        </el-table-column>
        <el-table-column label="Partner Rank" width="140">
          <template slot-scope="scope"
          >{{ scope.row.effectivePartnerRank }}
            {{ scope.row.partnerUsesSpecialRank ? "SR" : "" }}
          </template
          >
        </el-table-column>
      </el-table>
      <h2>Doubles Alternates</h2>
      <el-table
          style="width: 100%"
          :border="true"
          :data="entries.alternates"
          class="entries"
      >
        <el-table-column label="Pos" type="index" width="60"></el-table-column>
        <el-table-column label="Combined Rank" width="120">
          <template slot-scope="scope">{{ scope.row.rank }}</template>
        </el-table-column>
        <el-table-column label="Player" width="200">
          <template slot-scope="scope">
            <span v-bind:style="strikethroughWhenNotInAlt(scope.row)">
            {{ scope.row.player.lastName }}, {{ scope.row.player.firstName }}
            {{ suppressBlrRusNationality(scope.row.player.nationality) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Player Rank" width="135">
          <template slot-scope="scope"
          >{{ scope.row.effectivePlayerRank }}
            {{ scope.row.playerUsesSpecialRank ? "SR" : "" }}
          </template
          >
        </el-table-column>
        <el-table-column label="Partner" width="200">
          <template slot-scope="scope"
          >{{ scope.row.partner.lastName }},
            {{ scope.row.partner.firstName }}
            {{
              suppressBlrRusNationality(scope.row.partner.nationality)
            }}
          </template
          >
        </el-table-column>
        <el-table-column label="Partner Rank" width="140">
          <template slot-scope="scope"
          >{{ scope.row.effectivePartnerRank }}
            {{ scope.row.partnerUsesSpecialRank ? "SR" : "" }}
          </template
          >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {Loading} from "element-ui";
import moment from "moment";
import {mapGetters, mapActions} from "vuex";

export default {
  data() {
    return {
      tournamentIdentifier: "",
      componentKey: 0,
    };
  },
  mounted() {
    this.fetchTournamentsForAcceptanceListDoubles();
  },
  computed: {
    ...mapGetters("singlesEntrySystem", [
      "acceptedEntriesDoubles",
      "tournamentsForAcceptanceListDoubles",
    ]),
    entries() {
      this.componentKey; // very dirty hack to have this re-evaluated by trigger
      if (this.tournamentIdentifier !== "") {
        console.log(
            this.acceptedEntriesDoubles[this.tournamentIdentifier]
        );
        if (
            this.acceptedEntriesDoubles[this.tournamentIdentifier] &&
            this.acceptedEntriesDoubles[this.tournamentIdentifier]
                .Type
        ) {
          return [];
        }
        return this.acceptedEntriesDoubles[
            this.tournamentIdentifier
            ];
      }
    },
    tournaments() {
      let result = [];
      this.tournamentsForAcceptanceListDoubles.forEach(
          (element) => {
            let alGenerationDate = moment.utc(
                element.withdrawDDate.replace("00:00:00", "22:00:00")
            );
            if (alGenerationDate < moment.utc()) {
              result.push(element);
            }
          }
      );
      return result;
    },
  },
  methods: {
    ...mapActions("singlesEntrySystem", ["fetchAcceptanceListDoubles", 'fetchTournamentsForAcceptanceListDoubles']),
    selectTournament(tournamentIdentifier) {
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false,
      });
      let that = this;
      this.fetchAcceptanceListDoubles([tournamentIdentifier, "M"])
          .then(() => {
            that.$nextTick(() => {
              that.componentKey += 1;
              loader.close();
            });
          })
          .catch((error) => {
            that.$notify.error({
              title: "Error",
              message: error,
              duration: 0,
            });
            that.$nextTick(() => {
              that.componentKey += 1;
              loader.close();
            });
          });
    },
    suppressBlrRusNationality(string) {
      return string === "RUS" || string === "BLR" ? "" : "(" + string + ")";
    },
    strikethroughWhenNotInAlt(row) {
      return !row.isInAlt ? 'text-decoration: line-through; font-size: 12px' : '';
    },
  },
};
</script>

<style scoped>
.attribute-element {
  display: flex;
  border: 1px solid black;
  align-items: center;
}

.attribute-element .label {
  border-right: 1px solid black;
  padding: 4px;
  min-width: 100px;
  background-color: dimgray;
  color: white;
}

.attribute-element .data {
  width: 100%;
  padding-left: 6px;
  padding-top: 2px;
}

.result-area {
  margin-top: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/DoublesAcceptance.vue